export default "__VITE_ASSET__B246FBcS__"